import * as dealValidationSelectors from '@makemydeal/dr-dash-store/selectors/dealValidationSelectors';
import * as offerActionCreators from '@makemydeal/dr-dash-store/actions/offerActionCreators';
import * as offerPayloadUtil from '@makemydeal/dr-dash-store/utils/offerPayloadUtil';

import type { Selectors } from './selectors';
import { BuildPayloadPurpose } from '@makemydeal/dr-dash-bff-types';

export const openDealSaveOffer = (_selectors: Selectors) => (dispatch: any, getState: any) => {
    const state = getState();
    const offerSavePayload = offerPayloadUtil.buildOfferSavePayloadObject(state, BuildPayloadPurpose.OpenDeal);
    const dealValidationNode = dealValidationSelectors.getDealValidationState(state);
    const request = offerActionCreators.saveOfferRSAA({
        state,
        offerSavePayload: {
            ...offerSavePayload,
            dealValidationNode
        }
    });
    dispatch(request);
};
